import * as types from './actionTypes';


export const getRequest = id => {
  return {
    type: types.TRANSACTION_ITEM_REQUEST,
    id
  };
};
export const getSuccess = data => {
  return {
    type: types.TRANSACTION_ITEM_SUCCESS,
    payLoad: data
  };
};
export const getFailure = () => {
  return {
    type: types.TRANSACTION_ITEM_FAILURE
  };
};